import { Box } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import React, { useMemo } from 'react';
import { Block } from '../../services/entities/impl/blfApi/schemas/block';
import { flexCenter } from '../commonUI/cssClasses';
import { isValidBlock } from '../onboarding/onboardingUtils';

interface Props {
  block: Block;
}

const BlockReadyBadge: React.FC<Props> = ({ block }) => {
  const isValid = useMemo(() => isValidBlock(block), [block]);

  if (!isValid.isValid) {
    console.log(
      `Block ${block?.name} is not valid. Error: ${isValid.error}. Block detail: `,
      block
    );
  }

  return (
    <Tooltip title={isValid.error}>
      <Box
        sx={{
          position: 'absolute',
          top: '7px',
          right: '7px',
          width: '7px',
          height: '7px',
          ...flexCenter,
          borderRadius: '50%',
          bgcolor: (theme) =>
            isValid.isValid
              ? theme.colors.status.green.main
              : theme.colors.status.red.main,
        }}
      />
    </Tooltip>
  );
};
export default BlockReadyBadge;
